import type { VocabularyCategory } from '@/modules/learning/api/vocabulary';

const EMOJI: Partial<Record<VocabularyCategory, string>> = {
  animal: '🦁',
  food: '🍎',
  vehicle: '🚗',
  object: '📦',
  place: '🏫',
  person: '👤',
  plant: '🌳',
  emotion: '😊',
  action: '🏃',
  abstract: '📖',
  concept: '💡',
};

export function categoryEmoji(category?: string | null): string {
  if (!category) return '📖';
  return EMOJI[category as VocabularyCategory] || '📖';
}

export function entryBadgeLabel(entry: { has_image?: boolean; image_source?: string | null; image_required?: boolean }): string {
  if (!entry.image_required) return 'Not Required';
  if (entry.has_image) {
    if (entry.image_source === 'reused') return 'Reused Image';
    return 'Generated';
  }
  return 'Missing';
}

export function ttsStatusLabel(entry: {
  has_tts_word?: boolean;
  has_tts_context?: boolean;
  has_tts_example?: boolean;
  example_sentence?: string;
  context_sentence?: string;
}): string {
  const hasExample = Boolean((entry.example_sentence || '').trim());
  const hasContext = Boolean((entry.context_sentence || '').trim());
  const wordReady = Boolean(entry.has_tts_word);
  const contextReady = !hasContext || Boolean(entry.has_tts_context);
  const exampleReady = !hasExample || Boolean(entry.has_tts_example);
  if (wordReady && contextReady && exampleReady) return 'Ready';
  if (wordReady || contextReady || exampleReady) return 'Partial';
  return 'Missing';
}
